import { ExtraerSeriesAlmacen } from './extraser-series-almacen';

export class SelectValue {

  constructor(public id: number, public valor: string, public descripcion: string, public campoPrecedesor: number, public valoresCampoPredecesor: number[]) { }

  static toModel(json: string): SelectValue {
    const data = JSON.parse(json);
    return new SelectValue(data.Id, data.VALOR, data.DESCRIPCION, data.ID_CAMPO_VAL_PRED_PADRE, data.ID_CAMPO_VAL_PRED_HIJO);
  }
}

export class TemplateField {

  id: number;
  nombre: string;
  descripcion: string;
  idSerie: number;
  max: number;
  min: number;
  tipo: string;
  defaultValues: SelectValue[];
  value: string | number | Date | any[] | any;
  obligatorio: boolean;
  subtipo: string;
  errorMessage: string;
  multivalue: boolean;
  rango: number;
  instruccion: string;
  mantenerValor: boolean;
  VALOR_PORDEFECTO: string;

  constructor() { }

  static toModel(json: string): TemplateField {
    const data = JSON.parse(json);
    const toReturn = new TemplateField();
    toReturn.id = data.Id;
    toReturn.nombre = data.NOMBRE;
    toReturn.descripcion = data.DESCRIPCION;
    toReturn.idSerie = data.ID_SERIE;
    toReturn.max = data.MAX;
    toReturn.tipo = data.TIPO;
    toReturn.obligatorio = data.OBLIGATORIO;
    toReturn.subtipo = data.SUBTIPO;
    toReturn.rango = data.RANGO;
    toReturn.instruccion = data.INSTRUCCION;
    toReturn.mantenerValor = data.MANTENER_VALOR;
    toReturn.min = data.MIN;
    if (data.DefaultValues) {
      toReturn.defaultValues = data.DefaultValues.map((value: SelectValue) => SelectValue.toModel(JSON.stringify(value)));
    }
    toReturn.multivalue = data.MULTIVALOR;
    toReturn.VALOR_PORDEFECTO = data.VALOR_PORDEFECTO;
    return toReturn;
  }

  toDTO(): any {
    const toReturn = {};
    toReturn['Id'] = this.id;
    toReturn['NOMBRE'] = this.nombre;
    toReturn['DESCRIPCION'] = this.descripcion;
    toReturn['TIPO'] = this.tipo;
    toReturn['MULTIVALOR'] = this.multivalue;
    toReturn['RANGO'] = this.rango;
    toReturn['SUBTIPO'] = this.subtipo;
    toReturn['DefaultValues'] = this.getValues();
    toReturn['ID_SERIE'] = this.idSerie;

    return toReturn;
  }

  public clone(): TemplateField {

    const templateField = new TemplateField();
    templateField.id = this.id;
    templateField.nombre = this.nombre;
    templateField.descripcion = this.descripcion;
    templateField.idSerie = this.idSerie;
    templateField.max = this.max;
    templateField.tipo = this.tipo;
    templateField.defaultValues = !!this.defaultValues ? [...this.defaultValues] : undefined;
    templateField.value = !!this.value && this.value.constructor === Array ? [...(<any[]>this.value)] : this.value;
    templateField.obligatorio = this.obligatorio;
    templateField.subtipo = this.subtipo;
    templateField.errorMessage = this.errorMessage;
    templateField.multivalue = this.multivalue;
    templateField.rango = this.rango;
    templateField.instruccion = this.instruccion;
    templateField.mantenerValor = this.mantenerValor;
    templateField.min = this.min;
    templateField.VALOR_PORDEFECTO = this.VALOR_PORDEFECTO;

    return templateField;
  }

  private getValues(): any[] {
    const values: { Id: number, VALOR: any, DESCRIPCION?: any }[] = [];
    if (this.value instanceof Array) {
      this.value.map(val => values.push({ Id: val.id, VALOR: val.valor }));
    } else {
      values.push({ Id: this.id, VALOR: this.value });
    }

    return values;
  }

}

export class TemplateFieldsOrdered {
  campo: TemplateField;
  order: number;

  constructor() { }

  static toModel(json: string): TemplateFieldsOrdered {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new TemplateFieldsOrdered();

    toReturn.campo = TemplateField.toModel(JSON.stringify(data.CAMPO));
    toReturn.order = data.ORDEN;

    return toReturn;
  }
}

